export default __webpack_public_path__ + "navigation-examples-custom-server-thumbnail-v1-960-4361d8bae19c03f6398d80045a820387.png";